import "./Locations.css";
import { useT } from "@/i18n/context";
import { company } from "@/data/company";
import type { Address } from "@/data/company";

function PinIcon() {
  return (
    <svg
      className="office__pin"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7Z" />
      <circle cx="12" cy="9" r="2.5" />
    </svg>
  );
}

export function Locations() {
  const t = useT();
  const offices: { label: string; address: Address }[] = [
    { label: t.locations.registeredLabel, address: company.registeredOffice },
    { label: t.locations.operationalLabel, address: company.operationalOffice },
  ];
  return (
    <section id="locations" className="section section--alt locations">
      <div className="container">
        <h2 className="section__heading">{t.locations.heading}</h2>
        <div className="locations__grid" data-reveal="">
          {offices.map((o) => (
            <article key={o.label} className="office">
              <PinIcon />
              <p className="office__label">{o.label}</p>
              <h3 className="office__city">{o.address.city}</h3>
              <p className="office__addr">
                {o.address.street}<br />
                {o.address.zip} {o.address.city} ({o.address.province})
              </p>
              <a
                className="office__maps"
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(o.address.mapsQuery)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t.locations.mapsCta}
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M7 17L17 7M17 7H7M17 7v10" />
                </svg>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Locations;
